// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__I0vYO","image":"Header_image__3HykW","name":"Header_name__3cmyC","info":"Header_info__42N6J","infoRow":"Header_infoRow__2jGQ_"};